
import { ChatDocument } from '../../../../domain/documents/models/ChatDocument';
import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import {
    DeleteProGPTChatDocumentsRequest,
    UploadProGPTChatDocumentsRequest,
} from '../dtos/requests/ProGPTChatDocumentsRequest';
import { BaseService } from '../../../http/BaseHttpService';
import { mapProGPTDocumentsResponseToModels } from '../mappers/ProGPTDocumentMapper';
import { ProGPTKMDocumentsDto, ProGPTChatDocumentDto } from '../dtos/responses/ProGPTDocumentDto';
import { buildProGPTUrl } from '../../../../features/utils/buildProGPTUrl';
import { ProGPTResultDto } from '../dtos/responses/ProGPTResultDto';

export class ProGPTDocumentsService extends BaseService {
    public readonly providerType = ChatProviderType.ProGPT;

    constructor(private readonly baseUrl: string) {
        super();
    }

    // leave as is until updated by backend to return memory source or km thing
    public async uploadDocumentsAsync(
        request: UploadProGPTChatDocumentsRequest,
        accessToken: string,
    ): Promise<ProGPTResultDto<ProGPTKMDocumentsDto>> {
        const formData = new FormData();

        formData.append('ChatId', request.chatId);
        request.files.forEach((file) => {
            formData.append('Files', file);
        });

        return await this.getResponseAsync<ProGPTResultDto<ProGPTKMDocumentsDto>>(
            {
                url: buildProGPTUrl(this.baseUrl, `ChatSession/${request.chatId}/documents`),
                method: 'POST',
                body: formData,
            },
            accessToken,
        );
    }

    public async getDocumentsAsync(chatId: string, accessToken: string): Promise<ChatDocument[]> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTChatDocumentDto> | ProGPTResultDto<ProGPTChatDocumentDto[]>>(
            {
                url: buildProGPTUrl(this.baseUrl, `ChatSession/${chatId}/documents`),
                method: 'GET',
            },
            accessToken,
        );

        return mapProGPTDocumentsResponseToModels(response.value);
    }

    public async deleteDocumentsAsync(
        request: DeleteProGPTChatDocumentsRequest,
        accessToken: string,
    ): Promise<void> {
        return await this.getResponseAsync<void>(
            {
                url: buildProGPTUrl(this.baseUrl, `ChatSession/${request.chatId}/documents`),
                method: 'DELETE',
                body: request.fileIds,
            },
            accessToken,
        );
    }
}
